import { create } from 'zustand';
import {
	AdditionalBookingSectionEntity,
	BookingEntity,
	PassengerTypeEntity,
	RouteEntity,
	UserEntity,
} from 'Models/Entities';
import addOnStore from 'Models/AddOnStore';
import {
	CargoTabDto,
	FetchCargoTabData,
	FetchFreightTabData,
	FetchPassengerTabData,
	FreightTabDto,
	TicketsTabData,
} from 'Services/Api/_HumanWritten/BookingWizardDataService';
import { FerryBookingCreationDto } from 'Models/Dtos/BookingDtos';
import { PassengerDetail } from '../BookingWizardData/PassengerDetail';

interface WizardFetchedDataStore {
	customer: UserEntity | undefined;
	bookingBeingEdited: BookingEntity | null;
	ferryFilterData: {
		route: RouteEntity | null;
		passengerTypes: PassengerTypeEntity[];
	};
	fetchFerryFilterData: () => Promise<void>;
	ticketsTabData: TicketsTabData | null;
	fetchTicketsTabData: () => Promise<void>;
	passengerTabData: {
		previousPassengers: PassengerDetail[];
	};
	fetchPassengerTabData: (userId: string) => Promise<void>;
	vehicleTabData: CargoTabDto | null;
	fetchVehicleTabData: (bookingCreationDto: FerryBookingCreationDto) => Promise<void>;
	freightTabData: FreightTabDto | null;
	fetchFreightTabData: () => Promise<void>;
	addOnTabData: {
		addOnSections: AdditionalBookingSectionEntity[];
	};
	fetchAddOnTabData: () => Promise<void>;
	setCustomer(user: UserEntity): void;
}

export const useWizardFetchedDataStore = create<WizardFetchedDataStore>(set => ({
	customer: undefined,
	bookingBeingEdited: null,
	ferryFilterData: {
		route: null,
		passengerTypes: [],
	},
	ticketsTabData: {
		departureTickets: [],
		returningTickets: [],
	},
	passengerTabData: {
		previousPassengers: [],
	},
	vehicleTabData: null,
	freightTabData: null,
	addOnTabData: {
		addOnSections: [],
	},
	setCustomer(customer: UserEntity) {
		set(() => ({ customer: customer }));
	},
	fetchFerryFilterData: async () => {
		// TODO BW
		// const response = await fetch('/api/ferry-filter-data');
		// const data = await response.json();
		// set({ ferryFilterData: data });
	},
	fetchTicketsTabData: async () => {
		// TODO BW
		// const response = await fetch('/api/tickets-data');
		// const data = await response.json();
		// set({ ticketsTabData: data });
	},
	fetchPassengerTabData: async (userId: string) => {
		const data = await FetchPassengerTabData(userId);
		set({
			passengerTabData: {
				previousPassengers: data,
			},
		});
	},
	fetchVehicleTabData: async (bookingCreationDto: FerryBookingCreationDto) => {
		const data = await FetchCargoTabData(bookingCreationDto);
		set({ vehicleTabData: data });
	},
	fetchFreightTabData: async () => {
		const data = await FetchFreightTabData();
		set({ freightTabData: data });
	},
	fetchAddOnTabData: async () => {
		set({
			addOnTabData: {
				addOnSections: addOnStore.addOnSections,
			},
		});
	},
}));
